/**
 * api接口统一管理
 */
import { get, post } from "./http";

export const successCodeArr = [0, 200, 8011];
//  测试
export const demoLogin = (p) => get("/api/manage/role-menu", p);

//  登录
export const postLogin = (p) => post("/api/auth/login", p);

//  登出
export const loginOut = (p) => get("/api/auth/logout", p);

//  菜单
export const getMenu = (p) => get("/api/manage/role-menu", p);

//  获取投放数据看板-筛选条件
export const putDataMenu = (p) => get("/api/put-data/menu", p);

//  获取投放数据看板-筛选条件-媒体平台
export const putDataPlatform = (p) => get("/api/landpage/media-platform?", p);

//  获取投放数据看板-筛选条件-搜索数据
export const putDataGetChargeSum = (p) =>
  get("/api/put-data/get-charge-sum", p);

//  新-投放数据看板-筛选条件-搜索数据
export const putDataGetChargeSumNew = (p) =>
  get("/api/put-data/get-charge-sum-new", p);

// 获取投放数据看板-导出
export const putDataExport = (p) => get("/api/down/put-stats-report", p);

//  投放助理数据-获取投放助理
export const assistantList = (p) => get("/api/put-data/assistant-list", p);

//  投放助理数据-获取搜索条件
export const assistantMenu = (p) => get("/api/put-data/menu", p);

//  投放助理数据-搜索
export const assistantTableList = (p) =>
  get("/api/put-data/assistant-data-list", p);

//  投放助理数据-新增
export const assistantAddList = (p) =>
  post("/api/put-data/add-assistant-put-data", p);

//  投放助理数据-编辑
export const assistantEditList = (p) =>
  post("/api/put-data/edit-assistant-put-data", p);

//  投放助理数据-删除
export const assistantDelList = (p) =>
  post("/api/put-data/del-assistant-put-data", p);

//  投放助理数据-导出
export const assistantExport = (p) =>
  get("/api/down/assistant-stats-report", p);

//  投放助理数据-创意策划获取投手(非投手版)
export const assistantPutUser = (p) => get("/api/common/put-user", p);

//  投放效果跟踪页-获取表格参数
export const effectList = (p) => post("/api/put-data/list", p);

//  新-投放效果跟踪页-获取表格参数
export const effectBList = (p) => post("/api/put-data/new-list", p);

//  投放效果跟踪页-选择书城渠到获取相关的公众号列表
export const effectReceiveChannel = (p) =>
  get("/api/put-data/receive-channel", p);

//  投放效果跟踪页-新增确认按钮
export const effectInfo = (p) => post("/api/put-data/info", p);

//  投放效果跟踪页-编辑
export const effectUpdate = (p) => post("/api/put-data/update", p);

//  投放效果跟踪页-导出
export const effectExport = (p) => get("/api/down/put-data-report", p);

//  新投放效果跟踪页-导出
export const effectNewExport = (p) => get("/api/put-data/export-new", p);

// 公众号新增粉丝排行榜
export const gzhFansRank = (p) => get("/api/put-data/gzh-fans-rank", p);

// 公众号新增粉丝排行榜
export const panelWeekList = (p) => get("/api/put-data/week-count-data", p);

// 投放排行
export const dashboardRank = (p) => get("/api/put-data/rank", p);

// 投放数据统计投手维度
export const userCountData = (p) => get("/api/put-data/user-count-data", p);

// 投放数据统计-书籍维度 获取分类
export const bookCategoryList = (p) => get("/api/put-book/category-list", p);

// 投放数据统计-书籍维度 获取列表数据
export const bookStatsList = (p) => get("/api/put-book/stats-list", p);

// 投放数据统计-书籍维度 新增确认按钮
export const addBook = (p) => post("/api/put-book/add-book", p);

// 投放数据统计-书籍维度 编辑确认按钮
export const editBook = (p) => post("/api/put-book/edit-book", p);

// 投放数据统计-书籍维度 获取编辑数据
export const bookInfo = (p) => get("/api/put-book/book-info", p);

// 投放数据统计-书籍维度 导出
export const bookExport = (p) => get("/api/down/book-stats-report", p);

// 投放书籍(资源管理菜单项的) 获取列表数据
export const bookPutList = (p) => get("/api/put-book/book-list", p);

// 后台管理 用户列表
export const manageUser = (p) => get("/api/manage/user", p);

// 后台管理 用户列表 角色下拉
export const UserSelectRole = (p) => get("/api/common/select-role", p);

// 后台管理 用户列表 用户详情
export const UserInfo = (p) => get("/api/manage/user/info", p);

// 后台管理 用户列表 新增用户
export const UserAdd = (p) => post("/api/manage/user/add", p);

// 后台管理 用户列表 编辑用户
export const UserEdit = (p) => post("/api/manage/user/edit", p);

// 后台管理 用户列表 用户数据权限天数限制列表
export const UserDataAccess = (p) => get("/api/manage/user-data-access", p);

// 后台管理 用户列表 用户数据权限添加/编辑
export const UserAccessAdd = (p) => post("/api/manage/user-data-access/add", p);

// 后台管理 路由列表
export const routeList = (p) => get("/api/manage/route-list", p);

// 后台管理 路由列表 修改路由名字
export const routeEditName = (p) => post("/api/manage/route-edit-name", p);

// 后台管理 路由列表 一键同步路由
export const routeSync = (p) => get("/api/manage/route-sync", p);

// 后台管理 路由列表 路由分组
export const routeGroupName = (p) => post("/api/manage/route-group-name", p);

// 后台管理 角色列表
export const roleList = (p) => get("/api/manage/role", p);

// 后台管理 路由分组列表
export const routeListGroup = (p) => get("/api/manage/route-list-group", p);

// 后台管理 角色列表 新增角色
export const roleAdd = (p) => post("/api/manage/role/add", p);

// 后台管理 角色列表 编辑角色
export const roleEdit = (p) => post("/api/manage/role/edit", p);

// 后台管理 角色列表 角色权限详情
export const roleRouteInfo = (p) => get("/api/manage/role-route-info", p);

// 后台管理 角色列表 角色分配权限
export const roleSetRoute = (p) => post("/api/manage/role-set-route", p);

// 后台管理 菜单列表
export const menuTree = (p) => get("/api/manage/menu/tree", p);

// 后台管理 菜单列表 添加菜单
export const menuAdd = (p) => post("/api/manage/menu/add", p);

// 后台管理 菜单列表 编辑菜单
export const menuEdit = (p) => post("/api/manage/menu/edit", p);

// 后台管理 菜单列表 菜单删除
export const menuDel = (p) => post("/api/manage/menu/delete", p);

// 后台管理 菜单列表 Vue下拉列表
export const menuVueSelect = (p) => get("/api/common/select-vue", p);

// 后台管理 登录日志
export const getLoginLog = (p) => get("/api/auth/login-log", p);

// 后台管理 菜单列表 获取全部/所有用户下拉
export const logSelectUser = (p) => get("/api/common/select-user", p);

// 后台管理 VUE路径管理页面 获取列表
export const vuePathList = (p) => get("/api/manage/vue", p);

// 后台管理 VUE路径管理页面 新增
export const vuePathAdd = (p) => post("/api/manage/vue/add", p);

// 后台管理 VUE路径管理页面 编辑
export const vuePathEdit = (p) => post("/api/manage/vue/edit", p);

// 后台管理 获取用户详情
export const getUserInfo = (p) => get("/api/manage/user/info", p);

// 后台管理 个人密码修改
export const getUserEditPwd = (p) => post("/api/manage/user/quick-edit", p);

// 投放管理 落地页管理
export const landPageList = (p) => get("/api/landpage/link-list", p);

// 投放管理 落地页管理 落地页推广平台
export const landPagePlatform = (p) => get("/api/common/link/put-platform", p);

// 投放管理 落地页管理 落地页跳转方式
export const landPageJumpType = (p) => get("/api/common/link/jump-type", p);

// 投放管理 落地页管理 批量操作二次回传状态
export const editActivePayStatus = (p) =>
  post("/api/landpage/batch-edit-active-pay-status", p);

// 投放管理 落地页管理 可批量-落地页删除
export const landPageLinkDelete = (p) => post("/api/landpage/link-delete", p);

// 投放管理 落地页管理 复制落地页
export const landPageLinkCopy = (p) => post("/api/landpage/link-copy", p);

// 投放管理 落地页管理 落地页单个编辑
export const landPageSingleEdit = (p) =>
  post("/api/landpage/link-single-edit", p);

// 投放管理 落地页管理 回传比例 创建任务
export const setReportPerPlan = (p) =>
  post("/api/landpage/set-report-per-plan", p);

// 投放管理 落地页管理 落地页回传比率日志
export const logReportPer = (p) => get("/api/landpage/log-report-per", p);

// 投放管理 落地页管理 渠道公众号
export const landPageChannelGzh = (p) => get("/api/common/channel-gzh", p);

// 投放管理 落地页管理 360媒体id下拉列表
export const landPageSixMedia = (p) => get("/api/common/link/six-media", p);

// 投放管理 落地页管理 获取转换域名
export const getPutDomain = (p) => get("/api/marketing/get-put-domain", p);

// 投放管理 落地页管理 360媒体id对应落地页模板
export const landSixTemplate = (p) => get("/api/common/link/six-template", p);

// 投放管理 落地页管理 oppo下拉列表
export const landOppoList = (p) => get("/api/common/oppo-list", p);

// 投放管理 落地页管理 vivo下拉列表
export const landVivoList = (p) => get("/api/common/vivo-list", p);

// 投放管理 落地页管理 公众号绑定的小程序
export const landGzhXcx = (p) => get("/api/platform/auth-gzh/applets", p);

// 新增落地页 顶部图片上传
export const landAddUploadImage = (p) => post("/api/common/upload-image", p);

// 新增落地页 提交
export const landAddButton = (p) => post("/api/landpage/link-add", p);

// 新增落地页 360 获取众号二维码
export const landAddGzhCode = (p) => get("/api/common/select-gzh-qrcode", p);

// 编辑落地页 头条、百度 获取信息
export const landEditGet = (p) => get("/api/landpage/link-info", p);

// 编辑落地页 提交
export const landEditButton = (p) => post("/api/landpage/link-edit", p);

// 落地页 获取同步字段下拉
export const landSyncField = (p) => get("/api/common/link/sync-field", p);

// 落地页 获取当前落地页相同类型的公众号
export const landSameLink = (p) => get(`api/landpage/same-link?id=${p}`);

// 落地页 同步落地页
export const landSyncUpdate = (p) => post("/api/landpage/update-same-link", p);

// 媒体平台管理 获取列表
export const mediaPlatformList = (p) => get("/api/landpage/media-platform/", p);

// 媒体平台管理 媒体平台添加
export const mediaPlatformAdd = (p) =>
  post("/api/landpage/media-platform/add", p);

// 媒体平台管理 媒体平台编辑
export const mediaPlatformEdit = (p) =>
  post("/api/landpage/media-platform/edit", p);

// 媒体版位管理 获取列表
export const mediaPositionList = (p) => get("/api/landpage/media", p);

// 媒体平台管理 媒体平台添加
export const mediaPositionAdd = (p) => post("/api/landpage/media/add", p);

// 媒体平台管理 媒体平台编辑
export const mediaPositionEdit = (p) => post("/api/landpage/media/edit", p);

// 渠道列表 获取列表 / 渠道下拉
export const channelLists = (p) => get("/api/landpage/channel", p);

// 渠道列表 添加渠道
export const channelAdd = (p) => post("/api/landpage/channel/add", p);

// 渠道列表 编辑渠道
export const channelEdit = (p) => post("/api/landpage/channel/quick-edit", p);

// 渠道列表 渠道父级分类
export const channelEditParent = (p) =>
  get("/api/common/select-gzh-channel-parent", p);

// 投放公众号列表
export const putGzhList = (p) => get("/api/landpage/put-gzh", p);

// 投放公众号列表 - 推广平台下拉（这个顺序和/putlinkXcx等这些页面的不一样）
export const putGzhPlatform = (p) =>
  get("/api/common/put-gzh-promote-platform", p);

// 设置公众号appid
export const putGzhSetAppid = (p) => post("/api/landpage/put-gzh/set-appid", p);

// 设置公众号wechatid
export const putGzhSetWechatid = (p) =>
  post("/api/landpage/put-gzh/set-wechatid", p);

// 设置公众号管理员
export const putGzhSetUser = (p) => post("/api/landpage/put-gzh/set-user", p);

// 投放公众号列表 设置公众号回传平台
export const putGzhSetBd = (p) =>
  post("/api/landpage/put-gzh/set-bd-report-status", p);

// 投放公众号列表 是否展示 开启/关闭
export const putGzhSetShow = (p) => post("/api/landpage/put-gzh/set-status", p);

// 推广账户管理 负责人
export const putUserList = (p) => get("/api/common/put-user-list", p);

// 推广账户管理 开发者账户
export const putUserToutiaoList = (p) =>
  get("/api/account/toutiao-list?limit=10000", p);

// 推广账户管理 列表
export const putAdvList = (p) => get("/api/account/toutiao-adv-list", p);

// 推广账户管理 设置广告账户负责人-----巨量引擎账户页也有用到
export const putSetAdvUser = (p) => post("/api/account/set-adv-user", p);

// 推广账户管理 设置投放参数
export const putSetAdvPut = (p) => post("/api/account/set-adv-put", p);

// 推广账户管理 推广内容规划
export const putSetPlan = (p) => post("/api/account/edit-toutiao-adv", p);

// 开发者账户管理 同步子账户 同步广告主
export const syncMarketing = (p) => get("/api/marketing/sync-marketing", p);

// 开发者账户管理 编辑
export const editToutiaoAccount = (p) =>
  post("/api/account/edit-toutiao-account", p);

// 推广账户管理 OPPO
export const accountOppoList = (p) => get("/api/account/oppo-list", p);

// 推广账户管理 OPPO 新增
export const accountOppoAdd = (p) => post("/api/account/add-oppo-account", p);

// 推广账户管理 OPPO 编辑
export const accountOppoEdit = (p) => post("/api/account/edit-oppo-account", p);

// 推广账户管理 OPPO 删除
export const accountOppoDel = (p) => post("/api/account/del-oppo-account", p);

// 推广账户管理 VIVO 推广账户列表
export const accountVivoAdvList = (p) => get("/api/account/vivo-adv-list", p);

// 推广账户管理 VIVO 设置数据源ID
export const setVivoAdvSource = (p) =>
  post("/api/account/set-vivo-adv-source", p);

// 推广账户管理 VIVO 开发者账户列表
export const accountVivoDevList = (p) => get("/api/account/vivo-list", p);

// 推广账户管理 VIVO 开发者账户列表 编辑
export const accountVivoDevEdit = (p) =>
  get("/api/account/edit-vivo-account", p);

// 推广账户管理 VIVO 开发者账户列表 新增
export const accountVivoDevAdd = (p) => get("/api/account/add-vivo-account", p);

// 推广账户管理 VIVO 开发者账户列表 应用管理
export const accountVivoApplicationList = (p) =>
  get("/api/account/vivo-application-list", p);

// 推广账户管理 腾讯 授权账户列表
export const accAgentList = (p) => get("/api/adq/agent-list", p);

// 推广账户管理 腾讯 修改负责人
export const accAgentEditFZR = (p) => post("/api/adq/set-adv-user", p);

// 推广账户管理 腾讯 开发者账户列表
export const accAgentAccountList = (p) => get("/api/adq/account-list", p);

// 推广账户管理 腾讯 代理商账户列表 同步代理商MP或者ADQ
export const accAgentSyncMpAdq = (p) => get("/api/adq/sync/agent-son-adv", p);

// 推广账户管理 百度
export const accBaiduAdvList = (p) => get("/api/account/baidu-adv-list", p);

// 推广账户管理 百度 批量设置负责人
export const accBDSetAdvUser = (p) =>
  post("/api/account/set-baidu-adv-user", p);

// 推广账户管理 百度 管家账户管理
export const accBDAuthList = (p) => get("/api/account/baidu-auth-list", p);

// 推广账户管理 百度 同步推广账户
export const accBDsync = (p) => get("/api/account/sync-bd-adv-user", p);

// 推广账户管理 百度 设置a_key
export const accBDa_key = (p) => post("/api/account/edit-baidu-adv-akey", p);

// 推广账户管理 华为 列表
export const accountHWList = (p) => get("/api/account/huawei-list", p);

// 推广账户管理 华为 新增
export const accountHWAdd = (p) => post("/api/account/add-huawei-account", p);

// 推广账户管理 华为 编辑
export const accountHWEdit = (p) => post("/api/account/edit-huawei-account", p);

// 推广账户管理 华为 删除
export const accountHWDel = (p) => post("/api/account/del-huawei-account", p);

// 推广账户管理 快手 列表
export const accountKSList = (p) => get("/api/account/kuaishou-adv-list", p);

// 推广账户管理 快手 设置广告账户投手
export const accountKSsetAdmin = (p) =>
  post("/api/account/set-kuaishou-adv-user", p);

// 推广账户管理 快手 授权快手id列表
export const accountKSAuth = (p) => get("/api/account/kuaishou-auth-list", p);

// 推广账户管理 快手 同步快手id下广告主信息
export const accountKSAuthSync = (p) =>
  post("/api/account/sync-kuaishou-adv", p);

// 推广账户管理 快手 快手开发者账户信息
export const accountKSDev = (p) =>
  get("/api/account/kuaishou-dev-account-list", p);

// 推广账户管理 微博 广告主
export const accountWBadv = (p) => get("/api/account/weibo-adv-list", p);

// 推广账户管理 微博 开发者账户
export const accountWBDev = (p) => get("/api/account/weibo-account-list", p);

// 推广账户管理 微博 微博代理商
export const accountWBagent = (p) => get("/api/account/weibo-agent-list", p);

// 推广账户管理 微博 代理商同步广告主
export const accountWBsync = (p) => post("/api/account/weibo-sync-adv", p);

// 订单中心 公众号订单
export const orderGzhList = (p) => get("/api/order/gzh-order-list", p);

// 订单中心 公众号订单 手动回传
export const orderGzhReport = (p) => post("/api/order/gzh-order-report", p);

// 订单中心 公众号订单 自定义回传
export const orderGzhCustomReport = (p) =>
  post("/api/order/custom-report-order", p);

// 订单中心 公众号订单 手动回传mp，adq
export const orderGzhMpAdq = (p) => post("/api/mp/mp-report", p);

// 订单中心 公众号订单 导出
export const orderGzhExport = (p) => get("/api/down/gzh-order-report", p);

// 订单中心 点众订单 渠道号
export const dzChannelList = (p) => get("/api/common/dz/channel-list", p);

// 订单中心 点众订单 列表
export const dzOrderList = (p) => get("/api/order/dz-order-list", p);

// 订单中心 点众订单 导出
export const dzOrderExport = (p) => get("/api/down/dz-order-report", p);

// 订单中心 常读订单 列表
export const CdOrderList = (p) => get("/api/quick/changdu/order-list", p);

// 订单中心 常读订单 手动回传
export const CdOrderReport = (p) => post("/api/quick/changdu/order-report", p);

// 订单中心 常读订单 自定义回传
export const CdOrderCustomReport = (p) =>
  post("/api/quick/custom-report-changdu-order", p);

// 订单中心 常读订单 导出
export const CdOrderExport = (p) => get("/api/down/qk/changdu-order-report", p);

// 订单中心 文鼎订单 列表
export const WdOrderList = (p) => get("/api/quick/wending/order-list", p);

// 订单中心 文鼎订单 手动回传
export const WdOrderReport = (p) => post("/api/quick/wending/order-report", p);

// 订单中心 文鼎订单 自定义回传
export const WdOrderCustomReport = (p) =>
  post("/api/quick/custom-report-wending-order", p);

// 订单中心 文鼎订单 导出
export const WdOrderExport = (p) => get("/api/down/qk/wending-order-report", p);

// 订单中心 乐读订单 列表
export const LdOrderList = (p) => get("/api/quick/ledu/order-list", p);

// 订单中心 乐读订单 手动回传
export const LdOrderReport = (p) => post("/api/quick/ledu/order-report", p);

// 订单中心 乐读订单 自定义回传
export const LdOrderCustomReport = (p) =>
  post("/api/quick/custom-report-ledu-order", p);

// 订单中心 乐读订单 导出
export const LdOrderExport = (p) => get("/api/down/qk/ledu-order-report", p);

// 注册用户列表 公众号注册 列表
export const regGzhList = (p) => get("/api/user/gzh-user-list", p);

// 注册用户列表 公众号注册 手动回传
export const regGzhReport = (p) => post("/api/user/gzh-user-report", p);

// 注册用户列表 常读快应用注册 列表
export const regCdList = (p) => get("/api/quick/changdu/user-list", p);

// 注册用户列表 文鼎快应用注册 列表
export const regWdList = (p) => get("/api/quick/wending/user-list", p);

// 注册用户列表 乐读快应用注册 列表
export const regLdList = (p) => get("/api/quick/ledu/user-list", p);

// 快应用对应 媒体下拉渠道、推广平台下拉、媒体平台下拉
export const qkChannelMedia = (p) =>
  get("/api/common/select-qk-channel-media", p);

// 公众号对应 媒体下拉渠道、推广平台下拉、媒体平台下拉。这个接口的返回和api/common/put-gzh-promote-platform一样的
export const gzhChannelMedia = (p) =>
  get("/api/common/select-gzh-channel-media", p);

// 追书云 赠送书币操作 列表
export const zsyGiftList = (p) => get("/api/user/zhuishuyun-gzh-user-list", p);

// 落地页用户 自建落地页用户 列表
export const LdLinkUserList = (p) => get("/api/landpage/link-user-list", p);

// 落地页用户 自建落地页用户 联调头条事件
export const LdLinkUserReport = (p) =>
  post("/api/landpage/link-user-report", p);

// 落地页用户 基木鱼用户 列表
export const LdJmyList = (p) => get("/api/baidu/jimuyu-user", p);

// 落地页用户 基木鱼用户 手动回传
export const LdJmyReport = (p) => post("/api/baidu/report-jimuyu-user-xll", p);

// 落地页用户 巨量点击用户 列表
export const LdJlList = (p) => get("/api/marketing/click-log", p);

// 落地页用户 巨量点击用户 获取快应用和短剧渠道下拉
export const getQkVdChannel = (p) =>
  get("/api/common/select-qk-and-vd-channel", p);

// 落地页用户 360落地页用户 列表
export const LdSixList = (p) => get("/api/user/six-user-list", p);

// 落地页用户 360落地页用户 手动回传
export const LdSixReport = (p) => post("/api/user/six-user-report", p);

// 落地页用户 快手落地页用户 列表
export const LdKsList = (p) => get("/api/user/kuaishou-callback-log", p);

// 落地页用户 快手落地页用户 手动联调
export const LdKsReport = (p) => post("/api/user/kuaishou-user-report", p);

// 巨量引擎 账户 列表
export const JLzhList = (p) => get("/api/marketing/adv-list", p);

// 巨量引擎 账户 选择广告账户
export const JLzhSelectGgzh = (p) => get("/api/common/select-adv", p);

// 巨量引擎 账户 同步账户信息
export const JLzhSync = (p) =>
  get("/api/marketing/sync-marketing-group-plan-creative", p);

// 巨量引擎 账户 同步历史数据
export const JLzhSyncPlan = (p) =>
  get("/api/marketing/sync-marketing-plan-report", p);

// 巨量引擎 账户 同步历史数据2.0
export const JLzhSyncTwoPlan = (p) =>
  post("/api/marketing/sync-project-promotion-report", p);

// 巨量引擎 广告组 列表
export const JLggzList = (p) => get("/api/marketing/group-list", p);

// 巨量引擎 广告组 选择广告组
export const JLggzSelectGroup = (p) => get("/api/common/select-group", p);

// 巨量引擎 广告组 开启/关闭
export const JLggzEditStatus = (p) =>
  post("/api/marketing/edit-adv-group-status", p);

// 巨量引擎 广告组 同步计划
export const JLggzSyncPlan = (p) =>
  get("/api/marketing/sync-marketing-plan", p);

// 巨量引擎 计划 列表
export const JLjhList = (p) => get("/api/marketing/plan-list", p);

// 巨量引擎 计划 搜索条件（广告状态、操作状态）
export const JLjhSelectStatus = (p) => get("/api/common/select-plan-status", p);

// 巨量引擎 计划 广告计划选择器
export const JLjhSelectPlan = (p) => get("/api/common/select-plan", p);

// 巨量引擎 计划 当天统计
export const JLjhPlanDate = (p) => get("/api/marketing/plan-date-count", p);

// 巨量引擎 计划 开启/关闭
export const JLjhEditStatus = (p) =>
  post("/api/marketing/edit-adv-plan-status", p);

// 巨量引擎 计划 计划回传比例
export const JLjhReportConfig = (p) =>
  post("/api/marketing/edit-unit-report-config", p);

// 巨量引擎 计划 批量计划回传比例
export const JLjhPlReportConfig = (p) =>
  post("/api/marketing/batch-edit-unit-report-config", p);

// 巨量引擎 计划 导出
export const JLjhExport = (p) => get("/api/down/marketing-plan-report", p);

// 巨量引擎 计划 小时级eff追踪
export const JLjhHourEff = (p) => get("/api/marketing/adv-plan/hour-eff", p);

// 巨量引擎 计划 天级eff追踪
export const JLjhDayEff = (p) => get("/api/marketing/adv-plan/daily-eff", p);

// 巨量引擎 创意 列表
export const JLcyList = (p) => get("/api/marketing/creative-list", p);

// 巨量引擎 创意 开启/关闭
export const JLcyIdeaStatus = (p) =>
  post("/api/marketing/edit-adv-idea-status", p);

// 巨量引擎2.0 项目 列表
export const JLpjList = (p) => get("/api/marketing/project-list", p);

// 巨量引擎2.0 广告 列表
export const JLpmList = (p) => get("/api/marketing/promotion-list", p);

// 巨量引擎2.0 广告 导出
export const JLpmExport = (p) => get("/api/down/marketing-promotion-report", p);

// 巨量引擎2.0 广告 小时级eff追踪
export const JLpmHourEff = (p) =>
  get("/api/marketing/adv-promotion/hour-eff", p);

// 巨量引擎2.0 广告 天级eff追踪
export const JLpmDayEff = (p) =>
  get("/api/marketing/adv-promotion/daily-eff", p);

// 巨量引擎2.0 获取巨量项目下拉
export const JLpjSelect = (p) => get("/api/common/select-project", p);

// 巨量引擎2.0 广告 广告回传比例
export const JLpmReportConfig = (p) =>
  post("/api/marketing/edit-promotion-report-config", p);

// 巨量引擎2.0 广告 批量广告回传比例
export const JLpmPlReportConfig = (p) =>
  post("/api/marketing/batch-edit-promotion-report-config", p);

// 巨量引擎2.0 账户 设置广告主同步2.0项目
export const JLzh2setAdv = (p) => post("/api/account/set-adv-sync-project", p);

// 巨量引擎2.0 账户 同步2.0项目和广告
export const JLzh2syncProjectPromotion = (p) =>
  post("/api/marketing/sync-marketing-project-promotion", p);

// 百度 账户 列表
export const BDzhList = (p) => get("/api/account/baidu-adv-list", p);

// 百度 账户 选择广告账户
export const BDzhAdv = (p) => get("/api/common/select-bd-adv", p);

// 百度 账户 同步广告
export const BDzhSyncAdv = (p) => get("/api/baidu/sync-plan-unit-creative", p);

// 百度 计划 列表
export const BDjhList = (p) => get("/api/baidu/plan", p);

// 百度 计划 选择计划
export const BDjhSelectPlan = (p) => get("/api/common/select-bd-plan", p);

// 百度 创意 列表
export const BDcyList = (p) => get("/api/baidu/creative", p);

// 百度 创意 选择广告单元
export const BDcySelectUnit = (p) => get("/api/common/select-bd-unit", p);

// 百度 单元 列表
export const BDdyList = (p) => get("/api/baidu/unit", p);

// 百度 单元 计划回传比例
export const BDdyReportConfig = (p) =>
  post("/api/baidu/edit-unit-report-config", p);

// 百度 单元 批量计划回传比例
export const BDdyPlReportConfig = (p) =>
  post("/api/baidu/batch-edit-unit-report-config", p);

// 百度 单元 导出
export const BDdyExport = (p) => get("/api/down/baidu-unit-report", p);

// 百度 同步计划单元报表信息
export const BDsyncPlanReport = (p) =>
  get("/api/baidu/sync-plan-unit-creative-report", p);

// 百度看板 单元 小时级eff追踪
export const BDdyHourEff = (p) => get("/api/baidu/unit/hour-eff", p);

// 百度看板 单元 天级eff追踪
export const BDdyDayEff = (p) => get("/api/baidu/unit/daily-eff", p);

// 快手看板 账户 列表
export const KSzhList = (p) => get("/api/kuaishou/adv-list", p);

// 快手看板 账户 广告账户下拉
export const KSzhSelectAdv = (p) => get("/api/common/select-kuaishou-adv", p);

// 快手看板 账户 设置账户是否同步数据
export const KSzhSetSync = (p) =>
  post("/api/account/set-kuaishou-sync-data", p);

// 快手看板 账户 同步广告主账户广告计划和广告组信息
export const KSzhSyncPlanGroup = (p) =>
  post("/api/kuaishou/sync-plan-group", p);

// 快手看板 账户 广告账户同步账户计划组报表
export const KSzhSyncPlanGroupReport = (p) =>
  post("/api/kuaishou/sync-plan-group-report", p);

// 快手看板 计划 列表
export const KSjhList = (p) => get("/api/kuaishou/plan-list", p);

// 快手看板 计划下拉
export const KSPlanSelect = (p) => get("/api/common/select-kuaishou-plan", p);

// 快手看板 广告组 列表
export const KSggzList = (p) => get("/api/kuaishou/group-list", p);

// 快手看板 广告组下拉
export const KSggzSelect = (p) => get("/api/common/select-kuaishou-group", p);

// 快手看板 广告组批量修改回传设置
export const KSggzReportConfig = (p) =>
  post("/api/kuaishou/batch-edit-group-report-config", p);

// 运营公众号管理 获取搜索条件 - 渠道 投手/运营
export const opeGzhSelect = (p) => get("/api/common/select-openplaform", p);

// 运营公众号管理 获取小程序选择
export const opeGzhXcx = (p) => get("/api/common/select-user-applets", p);

// 运营公众号管理 列表
export const opeGzhList = (p) => get("/api/platform/auth-gzh", p);

// 运营公众号管理 设置管理员
export const opeGzhSetUser = (p) => post("/api/platform/auth-gzh/set-user", p);

// 运营公众号管理 设置公众号关注页链接
export const opeGzhSetJumpUrl = (p) =>
  post("/api/platform/auth-gzh/set-jump-url", p);

// 运营公众号管理 设置渠道
export const opeGzhSetChannel = (p) =>
  post("/api/platform/auth-gzh/set-channel", p);

// 运营公众号管理 同步公众号信息
export const opeGzhSyncGzhInfo = (p) => post("/api/platform/sync-gzh-info", p);

// 运营公众号管理 清空粉丝消息
export const opeGzhClearMessage = (p) =>
  post("/api/platform/auth-gzh/clear-message", p);

// 运营公众号管理 生成小程序码
export const opeGzhGenerateAppletCode = (p) =>
  post("/api/landpage/gzh-build-applets-scheme", p);

// 运营公众号管理 设置小程序 获取
export const opeGzhGetApplets = (p) => get("/api/platform/auth-gzh/applets", p);

// 运营公众号管理 设置小程序 确认请求
export const opeGzhEditApplets = (p) =>
  post("/api/platform/auth-gzh/edit-applets", p);

// 运营公众号管理 跳转微信客服管理 列表
export const opeGzhWxKf = (p) => get("/api/enterwx/kf", p);

// 运营公众号管理 跳转微信客服管理 获取企业下拉选择框
export const opeGzhSelectWxQy = (p) => get("/api/enterwx/account", p);

// 运营公众号管理 跳转微信客服管理 状态更改-解除绑定
export const opeGzhKfStatus = (p) => post("/api/enterwx/kf/status", p);

// 运营公众号管理 新建微信客服 头像上传
export const opeGzhAddImg = (p) => post("/api/enterwx/upload/image", p);

// 运营公众号管理 新建微信客服 确认请求
export const opeGzhAddKf = (p) => post("/api/enterwx/add/kf", p);

// 运营公众号管理 编辑-微信客服 确认请求
export const opeGzhEditKf = (p) => post("/api/enterwx/edit/kf", p);

// 运营公众号管理 人工添加客服-添加 确认请求
export const opeGzhManAddKf = (p) => post("/api/enterwx/manual-add/kf", p);

// 运营公众号管理 人工添加客服-编辑 确认请求
export const opeGzhManEditKf = (p) => post("/api/enterwx/manual-edit/kf", p);

// 运营公众号管理 跳转微信客服管理 状态切换
export const opeGzhChangeStatus = (p) => post("/api/enterwx/kf/status", p);

// 运营公众号管理 跳转微信客服管理 修改使用顺序
export const opeGzhChangeSort = (p) => post("/api/enterwx/edit/kf-sort", p);

// 小程序跳转码 列表
export const opeGzhSchemeCount = (p) =>
  get("/api/landpage/applets/scheme-count", p);

// 小程序跳转码 测试生成跳转码
export const xcxSchemeGenerate = (p) =>
  get("/api/landpage/applets/test-buile-scheme", p);

// 小程序跳转码 删除
export const xcxSchemeDel = (p) =>
  post("/api/landpage/applets/delete-jump-url", p);

// 小程序管理运营版 列表
export const xcxOperList = (p) => get("/api/landpage/applets", p);

// 小程序管理运营版 修改状态
export const xcxOperSetStatus = (p) =>
  post("/api/landpage/applets/set-status", p);

// 小程序管理运营版 设置运营人员
export const xcxOperSetUser = (p) => post("/api/landpage/applets/set-user", p);

// 小程序管理运营版 新增小程序
export const xcxOperAddXcx = (p) => post("/api/landpage/applets/add", p);

// 小程序管理运营版 编辑小程序
export const xcxOperEditXcx = (p) => post("/api/landpage/applets/edit", p);

// 小程序管理运营版 清空计数
export const xcxOperClearCount = (p) =>
  post("/api/landpage/applets/clear-count", p);

// 小程序管理运营版 重新生成小程序码
export const xcxOperClearXcxScheme = (p) =>
  post("/api/landpage/applets/clear-applets-scheme-again-build", p);

// 小程序管理运营版 批量操作公众号
export const xcxOperBatchGzh = (p) =>
  post("/api/landpage/applets/batch-gzh-status", p);

// 小程序管理运营版 批量替换小程序
export const xcxOperReplaceGzh = (p) =>
  post("/api/landpage/applets/replace-gzh-applets", p);

// 小程序管理运营版 获取小程序跳转文章链接
export const xcxOperGetJumpUrl = (p) =>
  get("/api/landpage/applets/applets-jump-url", p);

// 小程序管理运营版 提交小程序跳转文章链接
export const xcxOperAddJumpUrl = (p) =>
  post("/api/landpage/applets/add-applets-jump-url", p);

// 小程序跳转码每日使用量 列表
export const xcxUseList = (p) =>
  get("/api/landpage/applets/use-scheme-count", p);

// 小程序跳转码数量统计 列表
export const xcxDataList = (p) =>
  get("/api/landpage/applets/date-scheme-count", p);

// 文鼎推广链接 列表
export const wdPromoteLink = (p) => get("/api/quick/wending/promote-link", p);

// 文鼎推广链接 编辑渠道
export const wdPromoteEditQd = (p) => post("/api/quick/wending/edit-link", p);

// 文鼎推广链接 第三方代理商/授权第三方账户
export const wdPromoteThird = (p) => get("/api/common/select-agent", p);

// 文鼎推广链接 设置回传参数
export const wdPromoteReportConfig = (p) =>
  post("/api/quick/wending/edit-link-report-config", p);

// 乐读推广链接 列表
export const ldPutLinkList = (p) => get("/api/quick/ledu/promote-link", p);

// 乐读推广链接 编辑
export const ldPutLinkEdit = (p) => post("/api/quick/ledu/edit-link", p);

// 乐读推广链接 设置回传参数
export const ldPutLinkReportConfig = (p) =>
  post("/api/quick/ledu/edit-link-report-config", p);

// 投手天级统计：巨量 投手明细数据 列表
export const pitcherDailyList = (p) => get("/api/marketing/plan-user-count", p);

// 投手天级统计：巨量 投手汇总数据 列表
export const pitcherDailyHzList = (p) =>
  get("/api/marketing/plan-date-count", p);

// 投手-每日统计报表 获取列表
export const pitcherStatisList = (p) =>
  get("/api/put-data/stats-media-data-user", p);

// 投手-每日统计报表 导出
export const pitcherStatisExport = (p) =>
  get("/api/down/media-stats-report", p);

// 下载任务 筛选条件
export const downTaskSelect = (p) => get("/api/common/select-task-option", p);

// 下载任务 获取列表
export const downTaskList = (p) => get("/api/down/task-list", p);

// 点众渠道 获取列表
export const dzLinkList = (p) => get("/api/order/dz-channel-list", p);

// 点众渠道 新增
export const dzLinkAdd = (p) => get("/api/order/dz-add-channel", p);

// 常读推广链接 获取列表
export const cdPromoteList = (p) => get("/api/quick/changdu/promote-link", p);

// 常读推广链接 设置回传参数
export const cdPromoteReportConfig = (p) =>
  post("/api/quick/changdu/edit-link-report-config", p);

// 常读推广链接 编辑
export const cdPromoteEdit = (p) => post("/api/quick/changdu/edit-link", p);

// 常读推广链接 巨量联调(资产事件联调激活付费)
export const cdPromoteAssetsReport = (p) =>
  post("/api/marketing/assets-report", p);

// 常读推广链接 快应用华为联调
export const cdPromoteHwTest = (p) => post("/api/quick/huawei-report", p);

// 常读推广链接 获取华为账户下拉
export const cdPromoteHwSelect = (p) =>
  get("/api/common/select-huawei-account", p);

// 设计天级统计：巨量 获取列表
export const marketersDataList = (p) =>
  get("/api/put-data/toushou-alias/stats", p);

// 设计天级统计：巨量 获取列表 - 个人版
export const marketersDataDesignList = (p) =>
  get("/api/put-data/toushou-alias/design-stats", p);

// 设计天级统计：巨量 获取推广人员下拉选择列表
export const marketersDataSelectTg = (p) =>
  get("/api/common/select-toushou-alias", p);

// 巨量计划充值统计 获取列表
export const jlPlanList = (p) => get("/api/put-data/get-plan-charge", p);

// 百度单元充值统计 获取列表
export const bdPlanList = (p) => get("/api/put-data/get-new-bd-plan-charge", p);

// OPPO点击监测用户 获取列表
export const clickOppoList = (p) => get("/api/user/oppo-click-log", p);

// VIVO点击监测用户 获取列表
export const clickVivoList = (p) => get("/api/user/vivo-click-log", p);

// 华为点击监测用户 获取列表
export const clickHuaweiList = (p) => get("/api/user/huawei-click-log", p);

// 微博点击监测用户 获取列表
export const clickWeiboList = (p) => get("/api/user/weibo-callback-log", p);

// 微博点击监测用户 联调
export const weiboLianTiao = (p) => post("/api/weibo/liantiao", p);

// 腾讯ADQ点击用户 获取列表
export const clickTxADQList = (p) => get("/api/user/tencent-click-log", p);

// 百度点击用户 获取列表
export const clickBDList = (p) => get("/api/user/baidu-click-log", p);

// 推广/设计师列表 获取列表
export const toushouAliasList = (p) => get("/api/put-data/toushou-alias", p);

// 推广/设计师列表 编辑
export const toushouAliasEdit = (p) =>
  post("/api/put-data/toushou-alias/edit", p);

// 推广/设计师列表 新增
export const toushouAliasAdd = (p) =>
  post("/api/put-data/toushou-alias/add", p);

// 微博计划 获取列表
export const weiboPlanList = (p) => get("/api/weibo/ad-list", p);

// 微博计划 微博计划回传设置
export const weiboPlanReportConfig = (p) =>
  post("/api/weibo/edit-ad-report-config", p);

// 同步日志列表
export const taskSyncList = (p) => get("/api/marketing/sync-task", p);

// 同步日志列表 同步任务类型下拉
export const taskSyncPlatType = (p) =>
  get("/api/common/select-sync-plat-type", p);

// 渠道书库
export const libraryList = (p) => get("/api/book/list", p);

// 渠道书库 设为投放作品
export const librarySetPutBook = (p) => post("/api/book/set-put-book", p);

// 渠道书库 全本下载
export const libraryDownBook = (p) => post("/api/book/curl-local-book", p);

// 渠道书库下载任务
export const libraryDownList = (p) => get("/api/book/down-task-book", p);

// 渠道书库下载任务 新建作品下载任务
export const libraryDownAdd = (p) => post("/api/book/curl-book", p);

// 投手操作日志 列表
export const pitcherLogList = (p) =>
  get("/api/put-data/user-operate-history", p);

// 投手操作日志 历史操作数据下拉类型
export const pitcherLogType = (p) =>
  get("/api/common/select-money-operate-type", p);

// 数据字典 列表
export const dataDictList = (p) => get("/api/manage/dictionary", p);

// 数据字典 编辑状态
export const dataDictEditStatus = (p) =>
  post("/api/manage/dictionary/edit-status", p);

// 数据字典 添加
export const dataDictAdd = (p) => post("/api/manage/dictionary/add", p);

// 数据字典 编辑
export const dataDictEdit = (p) => post("/api/manage/dictionary/edit", p);

// 跳转企业微信-企业列表 列表
export const jumpQwList = (p) => get("/api/enterwx/account", p);

// 跳转企业微信-企业列表 添加
export const jumpQwAdd = (p) => post("/api/enterwx/account/add", p);

// 跳转企业微信-企业列表 编辑
export const jumpQwEdit = (p) => post("/api/enterwx/account/edit", p);

// 渠道书库-下载参数管理 列表
export const libDownList = (p) => get("/api/book/channel", p);

// 渠道书库-下载参数管理 编辑
export const libDownEdit = (p) => post("/api/book/set-channel-config", p);

// 代理商管理 列表
export const agentAdmList = (p) => get("/api/account/agent", p);

// 代理商管理 编辑状态
export const agentAdmChangeStatus = (p) =>
  post("/api/account/agent/edit-status", p);

// 代理商管理 新增
export const agentAdmAdd = (p) => post("/api/account/agent/add", p);

// 代理商管理 编辑状态
export const agentAdmEdit = (p) => post("/api/account/agent/edit", p);

// 代理商管理 代理商公众号列表
export const agentAdmGzhList = (p) => get("/api/common/channel-gzh-tree", p);

// 腾讯Adq和Mp回传设置列表
export const TxMpAdqHcList = (p) => get("/api/mp/config-list", p);

// 腾讯Adq和Mp回传设置 MP上报ADQ上报开关控制
export const TxMpAdqChangeOpen = (p) =>
  post("/api/mp/change-config-open-status", p);

// 腾讯Adq和Mp回传设置 MP上报方式切换
export const TxMpAdqCheckType = (p) => post("/api/mp/change-check-type", p);

// 腾讯Adq和Mp回传设置 新增腾讯回传设置
export const TxMpAdqAddReport = (p) => post("/api/mp/add-report-config", p);

// 腾讯Adq和Mp回传设置 编辑腾讯回传设置
export const TxMpAdqEditReport = (p) => post("/api/mp/edit-report-config", p);

// 腾讯Adq和Mp回传设置 删除腾讯回传设置
export const TxMpAdqDelReport = (p) => post("/api/mp/del-report-config", p);

// 腾讯Adq和Mp回传设置 编辑腾讯回传书籍书城
export const TxMpAdqEditBook = (p) => post("/api/mp/set-config-report-book", p);

// 腾讯ADQ企业微信方式切换
export const TxMpAdqChangeQywx = (p) => post("/api/mp/change-qywx-open", p);

// MP看板 账户 列表
export const MPzhList = (p) => get("/api/adq/adv-list", p);

// MP看板 账户 设置是否开启同步数据
export const MPzhSetSync = (p) => post("/api/adq/set-sync-data", p);

// MP看板 账户 同步账户信息
export const MPzhSyncAdv = (p) => post("/api/adq/sync/adv-base-data", p);

// MP看板 账户 同步历史数据
export const MPzhSyncReport = (p) => post("/api/adq/sync/adv-base-report", p);

// MP看板 计划 列表
export const MPjhList = (p) => get("/api/adq/plan-list", p);

// MP看板 广告 列表
export const MPggList = (p) => get("/api/adq/adv-group-list", p);

// MP看板 广告 导出
export const MPggExport = (p) => get("/api/down/adq-mp-report", p);

// MP看板 广告 修改回传设置
export const MPggReportConfig = (p) =>
  post("/api/adq/batch-edit-group-report-config", p);

// MP看板 广告账户下拉列表
export const MPggSelectAcc = (p) => get("/api/common/select-adq-adv", p);

// MP看板 小时级eff追踪
export const MPggHourEff = (p) => get("/api/adq/adv-group/hour-eff", p);

// MP看板 天级eff追踪
export const MPggDayEff = (p) => get("/api/adq/adv-group/daily-eff", p);

// 快应用落地页管理 列表
export const landQAList = (p) => get("/api/quick/landpage", p);

// 快应用落地页管理 快应用下拉联动
export const landQASelect = (p) => get("/api/common/select-qk-link", p);

// 快应用落地页管理 快应用落地页详情
export const landQaInfo = (p) => get("/api/quick/landpage-info", p);

// 快应用落地页管理 删除
export const landQaDel = (p) => post("/api/quick/del-landpage", p);

// 快应用落地页管理 添加
export const landQaAdd = (p) => post("/api/quick/add-landpage", p);

// 快应用落地页管理 编辑
export const landQaEdit = (p) => post("/api/quick/edit-landpage", p);

// 本地图文模板 列表
export const materialList = (p) => get("/api/platform/gzh-local-message", p);

// 本地图文模板 新增
export const materialAdd = (p) =>
  post("/api/platform/add-gzh-local-message", p);

// 本地图文模板 运营渠道和运营人员 下拉框
export const materialChannelSelect = (p) =>
  get("/api/common/select-openplaform", p);

// 本地图文模板 历史素材 下拉框 1=历史标题，2=封面图，3=微信二维码底图，4=继续阅读底图
export const materialLocalMessage = (p) =>
  get("/api/platform/gzh-local-message/material", p);

// 本地图文模板 详情
export const materialInfo = (p) =>
  get("/api/platform/gzh-local-message-info", p);

// 本地图文模板 编辑
export const materialEdit = (p) =>
  post("/api/platform/edit-gzh-local-message", p);

// 本地图文模板 删除
export const materialDel = (p) =>
  post("/api/platform/del-gzh-local-message", p);

// 本地图文模板 复制
export const materialCopy = (p) =>
  post("/api/platform/copy-gzh-local-message", p);

// 本地图文模板 同步到微信
export const materialSyncWx = (p) =>
  post("/api/platform/gzh-local-message/sync-wechat", p);

// 本地图文模板 解析推广链接中书籍信息
export const materialCodeUrl = (p) =>
  post("/api/platform/gzh-local-message/get-url-book", p);

// 本地图文模板 获取运营公众号渠道以及父类信息
export const materialSelectChannel = (p) =>
  get("/api/common/select-openplaform-channel", p);

// 本地图文模板 乐读书城常用地址下拉 / 插入链接弹窗里的下拉框
export const getBookOftenLink = (p) =>
  get("/api/common/select-book-often-link", p);

// 公众号分组
export const gzhGroupList = (p) => get("/api/platform/gzh-group", p);

// 公众号分组 添加
export const gzhGroupAdd = (p) => post("/api/platform/add-gzh-group", p);

// 公众号分组 编辑
export const gzhGroupEdit = (p) => post("/api/platform/edit-gzh-group", p);

// 公众号分组 删除
export const gzhGroupDel = (p) => post("/api/platform/del-gzh-group", p);

// 公众号分组 获取渠道下对应分组和未分组
export const gzhGroupGet = (p) => get("/api/platform/gzh-group/get-channel", p);

// 同步微信操作记录
export const gzhGroupTask = (p) =>
  get("/api/platform/gzh-local-message/sync-task", p);

// 同步微信操作记录 重试
export const gzhSyncRetry = (p) =>
  post("/api/platform/gzh-local-message/sync-wechat-again", p);

// 同步微信操作记录 - 复制草稿到其他公众号
export const gzhDraftCopyLog = (p) =>
  post("/api/platform/gzh-draft/copy-log", p);

// 微信图文消息：草稿箱
export const wxMaterialDraft = (p) => get("/api/platform/gzh-draft", p);

// 微信图文消息：草稿箱 预览
export const wxMaterialPreview = (p) =>
  post("/api/platform/gzh-draft/preview", p);

// 微信图文消息：草稿箱 删除
export const wxMaterialDel = (p) => post("/api/platform/gzh-draft/delete", p);

// 微信图文消息：草稿箱 群发
export const wxMaterialSend = (p) =>
  post("/api/platform/gzh-draft/send-user", p);

// 微信图文消息：草稿箱 批量群发
export const wxMaterialBatchSend = (p) =>
  post("/api/platform/gzh-draft/batch-send-user", p);

// 微信图文消息：草稿箱 渠道-公众号 下拉
export const wxMaterialSelect = (p) =>
  get("/api/common/select-openplaform-channnel-gzh", p);

// 微信图文消息：草稿箱 同时获取所有渠道和公众号 下拉
export const wxMaterialAllSelect = (p) =>
  get("/api/common/select-all-gzh-group-channel", p);

// 微信图文消息：草稿箱 标签列表
export const wxMaterialTag = (p) => get("/api/platform/gzh-tag/list", p);

// 微信图文消息：草稿箱 微信草稿箱手动同步
export const wxMaterialDraftSync = (p) =>
  post("/api/platform/gzh-draft-sync", p);

// 微信图文消息：草稿箱 获取公众号二维码
export const wxGetGzhCode = (p) => get("/api/platform/gzh/info", p);

// 微信图文消息：草稿箱 编辑-获取详情
export const wxDraftInfo = (p) => get("/api/platform/draft/info", p);

// 微信图文消息：草稿箱 批量选择公众号下粉丝数和默认星标组人数
export const wxPlGzhTagFans = (p) => get("/api/platform/gzh/tag-fans-count", p);

// 微信图文消息：草稿箱 公众号草稿复制到其它公众号
export const wxCopyDrafts = (p) =>
  post("/api/platform/gzh-draft/copy-to-other", p);

// 微信图文消息：草稿箱 发表记录 公众号草稿箱批量复制自己
export const wxCopySelf = (p) => post("/api/platform/gzh-draft/copy-self", p);

// 定时群发管理 图文群发日志
export const massSendTask = (p) => get("/api/platform/gzh-draft/send-task", p);

// 定时群发管理 图文群发日志 取消
export const massSendTaskCancel = (p) =>
  get("/api/platform/gzh-draft/send-task-cancel", p);

// 定时群发管理 批量删除群发文章
export const massSendTaskDel = (p) =>
  post("/api/platform/gzh-draft/send-message-batch-delete", p);

// 定时群发管理 删除单个已群发文章内容
export const massSendCellDel = (p) =>
  post("/api/platform/gzh-draft/send-message-delete", p);

// 投放分组 列表
export const putGroupList = (p) => get("/api/landpage/group", p);

// 投放分组 添加
export const putGroupAdd = (p) => post("/api/landpage/group/add", p);

// 投放分组 编辑
export const putGroupEdit = (p) => post("/api/landpage/group/edit", p);

// 视频小程序-推广链接列表
export const videoXcxList = (p) => get("/api/video-applets/promote-link", p);

// 视频小程序-推广链接列表 编辑
export const videoXcxEdit = (p) => post("/api/video-applets/edit-link", p);

// 视频小程序-推广链接列表 设置视频小程序推广链接回传参数
export const videoXcxReport = (p) =>
  post("/api/video-applets/edit-link-report-config", p);

// 视频小程序-注册用户 列表
export const videoXcxRegisterList = (p) =>
  get("/api/video-applets/user-list", p);

// 视频小程序-订单中心 列表
export const videoXcxOrderList = (p) => get("/api/video-applets/order-list", p);

// 视频小程序-订单中心 手动回传
export const videoXcxOrderReport = (p) =>
  post("/api/video-applets/order-report", p);

// 视频小程序-订单中心 自定义回传
export const videoXcxOrderCustomReport = (p) =>
  post("/api/video-applets/custom-report-order", p);

// 视频小程序-订单中心 导出
export const videoXcxOrderEeport = (p) =>
  get("/api/down/applets-order-report", p);

// 视频小程序-批量创建推广链接
export const videoXcxPlTgLink = (p) =>
  post("/api/video-applets/create-link", p);

// 智能图文推送管理 列表
export const imgtxtList = (p) => get("/api/platform/imgtxt/gzh-list", p);

// 智能图文推送管理 公众号图文发送配置日志详情
export const imgtxtLog = (p) => get("/api/platform/imgtxt/send-log", p);

// 智能图文推送管理 智能图文公众号开关配置
export const imgtxtGzhSwitch = (p) =>
  post("/api/platform/imgtxt/set-gzh-imgtxt-button", p);

// 智能图文消息管理 列表
export const imgtxtMsgList = (p) => get("/api/platform/imgtxt/send-config", p);

// 智能图文消息管理 编辑
export const imgtxtMsgEdit = (p) =>
  post("/api/platform/imgtxt/edit-send-config", p);

// 智能图文消息管理 删除
export const imgtxtMsgDel = (p) =>
  post("/api/platform/imgtxt/del-send-config", p);

// 智能图文消息管理 添加
export const imgtxtMsgAdd = (p) =>
  post("/api/platform/imgtxt/add-send-config", p);

// 关注后回复 列表
export const followReplyList = (p) =>
  get("/api/platform/default-message/gzh-list", p);

// 关注后回复 公众号默认消息列表
export const followReplyMsg = (p) =>
  get("/api/platform/default-message/list", p);

// 关注后回复 侧边栏 关注后回复消息-编辑
export const followReplyMsgEdit = (p) =>
  post("/api/platform/default-message/edit-message", p);

// 关注后回复 侧边栏 关注后回复消息-编辑-状态开关
export const followMsgEditStatus = (p) =>
  post("/api/platform/default-message/edit-status", p);

// 关注后回复 侧边栏 关注后回复消息-新增
export const followReplyMsgAdd = (p) =>
  post("/api/platform/default-message/add-message", p);

// 关注后回复 侧边栏 关注后回复消息-删除
export const followReplyMsgDel = (p) =>
  post("/api/platform/default-message/del-message", p);

// 关注后回复 侧边栏 关注后回复消息-预览
export const followReplyMsgPreview = (p) =>
  post("/api/platform/default-message/send-test", p);

// 粉丝列表
export const gzhFansList = (p) => get(`/api/platform/gzh/user/${p.gzh_id}`, p);

// 粉丝列表 - 城市列表
export const gzhFansCity = (p) => get(`/api/platform/wechat/city`, p);

// 粉丝列表 - 新增标签
export const gzhFansAddTag = (p) => get(`/api/platform/gzh-tag/create`, p);

// 粉丝列表 - 同步标签
export const gzhFansSyncTag = (p) => get(`/api/platform/gzh-tag/sync`, p);

// 粉丝列表 - 删标签/打标签
export const gzhFansHandleTag = (p) =>
  post(`/api/platform/gzh-tag/update-user`, p);

// 粉丝列表 - 一键标签
export const gzhFansQuickTag = (p) => get(`/api/platform/gzh-tag/quick-tag`, p);

// 粉丝列表 - 粉丝备注
export const gzhFansRemark = (p) =>
  post(`/api/platform/gzh/update-fans-remark`, p);

// 标签管理 列表
export const gzhTagList = (p) => get(`/api/platform/gzh-tag/gzh-list`, p);

// 标签管理 公众号对应标签列表-这个接口上面有重复的，但是也不想用上面的了
export const gzhTagTable = (p) => get(`/api/platform/gzh-tag/list`, p);

// 标签管理 删除标签
export const gzhTagDel = (p) => post(`/api/platform/gzh-tag/del`, p);

// 赠送书币操作
export const otherCurrency = (p) => post(`/api/user/send-user-coin`, p);

// 赠送书币 第三方用户赠送书币记录
export const otherCurrencyLog = (p) => get(`/api/user/send-user-coin/log`, p);

// 公众号粉丝聊天 - 获取渠道
export const gzhFansChannelList = (p) => get(`/api/platform/channel/list`, p);

// 公众号粉丝聊天 - 获取公众号下的聊天列表
export const gzhFansMsgList = (p) =>
  get(`/api/platform/gzh/message-user-list`, p);

// 公众号粉丝聊天 - 获取公众号的消息数量
export const gzhFansMsgRead = (p) =>
  get(`/api/platform/gzh/message-no-read`, p);

// 公众号粉丝聊天 - 获取聊天对话窗口信息
export const gzhFansChat = (p) => get(`/api/platform/gzh/fans-msg-list`, p);

// 公众号粉丝聊天 - 发送消息
export const gzhFansSendMsg = (p) =>
  post(`/api/platform/gzh/send-user-message`, p);

// 公众号粉丝聊天 - 获取图库里的图片
export const gzhFansGetImg = (p, id) =>
  get(`api/platform/gzh/material/${id}`, p);

// 公众号粉丝聊天 - 同步图库里的图片
export const gzhFansSyncImg = (id) =>
  get(`api/platform/gzh/material-sync/${id}`);

// 公众号底部菜单管理-新增
export const gzhMenuAdd = (p) => post(`/api/wechat/gzh/menu-create`, p);

// 公众号底部菜单管理-获取详情
export const gzhMenuInfo = (p) => get(`/api/wechat/gzh/menu-info`, p);

// 公众号关键词回复-列表
export const gzhKeywordList = (p) =>
  get(`/api/platform/keyword-message/list`, p);

// 公众号关键词回复-新增
export const gzhKeywordAdd = (p) =>
  post(`/api/platform/keyword-message/add-message`, p);

// 公众号关键词回复-编辑
export const gzhKeywordEdit = (p) =>
  post(`/api/platform/keyword-message/edit-message`, p);

// 公众号关键词回复-删除
export const gzhKeywordDel = (p) =>
  post(`/api/platform/keyword-message/del-message`, p);

// 公众号关键词回复-编辑状态
export const gzhKeywordStatus = (p) =>
  post(`/api/platform/keyword-message/edit-status`, p);

// 公众号-延迟客服消息-列表
export const gzhContactList = (p) => get(`/api/platform/delay-message/list`, p);

// 公众号-延迟客服消息-新增
export const gzhContactAdd = (p) =>
  post(`/api/platform/delay-message/add-message`, p);

// 公众号-延迟客服消息-编辑
export const gzhContactEdit = (p) =>
  post(`/api/platform/delay-message/edit-message`, p);

// 公众号-延迟客服消息-删除
export const gzhContactDel = (p) =>
  post(`/api/platform/delay-message/del-message`, p);

// 公众号-延迟客服消息-编辑状态
export const gzhContactStatus = (p) =>
  post(`/api/platform/delay-message/edit-status`, p);

// 公众号配置模板替换词
export const templateReplaceWord = (p) =>
  get(`/api/gzh-config-template/replace-word-list`, p);

// 公众号配置模板标签列表
export const templateTagList = (p) =>
  get(`/api/gzh-config-template/tag-list`, p);

// 公众号配置模板-添加标签
export const templateAddTag = (p) =>
  post(`/api/gzh-config-template/add-tag`, p);

// 公众号配置模板-添加标签
export const templateAdd = (p) => post(`/api/gzh-config-template/add`, p);

// 公众号配置模板-选择下拉框
export const templateSelect = (p) =>
  get(`/api/gzh-config-template/list-select`, p);

// 公众号配置模板-列表
export const templateList = (p) => get(`/api/gzh-config-template/list`, p);

// 公众号配置模板-根据公众号来获取公众号下模板的信息
export const templateGzhGet = (p) => get(`/api/gzh-config-template/gzh-get`, p);

// 公众号配置模板-详情
export const templateGetInfo = (p) => get(`/api/gzh-config-template/info`, p);

// 公众号配置模板-编辑
export const templateEdit = (p) => post(`/api/gzh-config-template/edit`, p);

// 公众号配置模板-公众号下模板变量设置
export const templateVarEdit = (p) =>
  post(`/api/gzh-config-template/gzh-edit`, p);

// 公众号配置模板列表-获取该模板下的配置公众号内容
export const templateGzhList = (p) =>
  get(`/api/gzh-config-template/template-gzh-list`, p);

// 公众号配置模板-清空选择的模板
export const templateDelete = (p) => post(`/api/gzh-config-template/delete`, p);

// 公众号菜单管理页-获取渠道下对应分组和未分组以及相应公众号-带搜索
export const getChannelGzh = (p) =>
  get(`/api/platform/gzh-group/get-channel-and-search-gzh`, p);

// 联调工具 快手联调
export const linkToolKs = (p) => post("/api/kuaishou/liantiao", p);

// 联调工具 oppo快应用联调付费
export const linkToolOppo = (p) => post("/api/oppo/liantiao", p);

// 联调工具 vivo快应用联调付费
export const linkToolVivo = (p) => post("/api/vivo/liantiao", p);

// 联调工具 百度转化联调
export const linkToolBd = (p) => post("/api/baidu/liantiao", p);

// 作品分类-列表
export const putCategoryList = (p) => get(`/api/put-book/category-list`, p);

// 作品分类-新建
export const putCategoryAdd = (p) => post(`/api/put-book/category/add`, p);

// 作品分类-编辑
export const putCategoryEdit = (p) => post(`/api/put-book/category/edit`, p);

// 短剧，小说小程序下拉
export const selectXsVdApplets = (p) =>
  get(`/api/common/select-xs-vd-applets`, p);

// 小程序列表
export const getXcxList = (p) => get(`/api/video-applets/applets-list`, p);

// 小程序列表-新增
export const xcxListAdd = (p) => post(`/api/video-applets/applets-add`, p);

// 小程序列表-编辑
export const xcxListEdit = (p) => post(`/api/video-applets/applets-edit`, p);

// 小程序列表-设置小程序账户投手
export const xcxListSetUser = (p) =>
  post("/api/video-applets/set-applets-user", p);

// 微博看板 账户 列表
export const WBzhList = (p) => get("/api/weibo/adv-list", p);

// 微博 设置投手
export const WbSetAdvUser = (p) => post("/api/account/weibo-set-adv-user", p);

// 微博看板 账户 设置广告主是否同步数据
export const WBzhSetSync = (p) => post("/api/weibo/set-sync-data", p);

// 微博看板 账户 同步历史数据
export const WBzhAdvBaseReport = (p) =>
  post("/api/weibo/sync/adv-base-report", p);

// 微博看板 账户 同步基础信息
export const WBzhAdvBaseData = (p) => post("/api/weibo/sync/adv-base-data", p);

// 微博看板 微博广告主下拉
export const WbAdvSelect = (p) => get("/api/common/select-weibo-adv", p);

// 微博看板 微博广告系列下拉
export const WbCamgaginSelect = (p) =>
  get("/api/common/select-weibo-campagin", p);

// 微博看板 广告系列
export const WbggList = (p) => get("/api/weibo/campaign-list", p);

// 微博看板 广告计划
export const WbjhList = (p) => get("/api/weibo/plan-list", p);

// 微博看板 广告计划下拉
export const WbjhSelect = (p) => get("/api/common/select-weibo-plan", p);

// 微博看板 广告计划 小时级eff追踪
export const WbjhHourEff = (p) => get("/api/weibo/plan-hour-eff", p);

// 微博看板 广告计划 天级eff追踪
export const WbjhDayEff = (p) => get("/api/weibo/plan-daily-eff", p);

// 公众号统计页面
export const gzhMonthlyList = (p) =>
  get("/api/platform/gzh-draft/send-month-count", p);

// 公众号统计页面 获取公众号组
export const getGzhGroup = (p) => get("/api/common/select-gzh-group", p);

// 运营公众号下拉 根据渠道获取公众号-运营版
export const getOperateGzh = (p) =>
  get("/api/common/select-openplaform-gzh", p);

// 投放作品、投放书籍 下拉接口
export const getBookList = (p) => get("/api/common/book-list", p);

// 看板 通用设置-设置广告账户推广内容
export const setAdvContentType = (p) =>
  post("/api/common/set-adv-content-type", p);

// -！！！！-----注意！注意！这部分是不需要复制到vue3项目去的，以为是那边已有的，是从那边复制过来的--------
// 本地素材 巨量广告账户主体下拉
export const getCommonSelectAdvCompany = (p) =>
  get(`/api/common/select-adv-company`, p);

//  星图点击用户
export const userXingtuClickLog = (p) => get("/api/user/xingtu-click-log", p);
//  星图点击用户
export const userBilibiliClickLog = (p) => get("/api/user/bsite-click-log", p);
// /api/user/bsite-liantiao
export const liantiaoClickApi = (p) => get("/api/user/bsite-liantiao", p);
// /api/gzh-config-template/quick-edit

export const templateEditApi = (p) =>
  post("/api/gzh-config-template/quick-edit", p);

export const setContentType = (p) =>
  post("/api/platform/auth-gzh/set-content-type", p);

export const shareGzhLocal = (p) =>
  post("/api/platform/share-gzh-local-message", p);

// /api/platform/gzh-local-tag/list
export const getLocalGzhTagList = (p) =>
  get("/api/platform/gzh-local-tag/list", p);

// /api/platform/gzh-local-tag/sync-to-gzh
export const tagSyncToGzh = (p) =>
  post("/api/platform/gzh-local-tag/sync-to-gzh", p);

// /api/common/select-gzh-local-tag

export const getSelectTagList = (p) =>
  get("/api/common/select-gzh-local-tag", p);

//  /api/mp/replace-api-version
export const replaceApiVersion = (p) => post("/api/mp/replace-api-version", p);
